import React from "react";
import { Card, Col, Divider, Row, Typography, Table } from "antd";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    templateProdDetail,
    chargeTableSource,
    configureFundTableSource,
    mapFeeTableSource,
    mapPenaltyTableSource,
    showAdvancedAccounting,
  } = props;

  const data = {
    details: [
      {
        name: "Product Name",
        value: formData?.details?.name ? formData.details.name : "-",
      },
      {
        name: "Short Name",
        value: formData?.details?.shortName ? formData.details.shortName : "-",
      },
      {
        name: "Description",
        value: formData?.details?.description ? formData.details.description : "-",
      },
    ],

    currency: [
      {
        name: "Currency",
        value: formData?.currency?.currencyCode ? formData.currency.currencyCode : "-",
      },
      {
        name: "Decimal Places",
        value: formData?.currency?.digitsAfterDecimal ? formData.currency.digitsAfterDecimal : "-",
      },
      {
        name: "Currency In Multiples Of",
        value: formData?.currency?.inMultiplesOf ? formData.currency.inMultiplesOf : "-",
      },
    ],

    terms: [
      {
        name: "Nominal Annual Interest(%)",
        value: formData?.terms?.nominalAnnualInterestRate
          ? formData?.terms?.nominalAnnualInterestRate
          : "-",
      },
      {
        name: "Interest Compounding Period",
        value: formData?.terms?.interestCompoundingPeriodType
          ? templateProdDetail?.interestCompoundingPeriodTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestCompoundingPeriodType,
            )?.value
          : "-",
      },
      {
        name: "Interest Posting Period",
        value: formData?.terms?.interestPostingPeriodType
          ? templateProdDetail?.interestPostingPeriodTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestPostingPeriodType,
            )?.value
          : "-",
      },
      {
        name: "Forfeit Interest",
        value:
          formData?.terms?.forfeitInterest === true
            ? "Yes"
            : formData?.terms?.forfeitInterest === false
              ? "No"
              : "--",
      },
      {
        name: "Number of Withdrawals Threshold",
        value: formData?.terms?.withdrawalCount ? formData.terms.withdrawalCount : "-",
      },
      {
        name: "Interest Calculated Using",
        value: formData?.terms?.interestCalculationType
          ? templateProdDetail?.interestCalculationTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestCalculationType,
            )?.value
          : "-",
      },
      {
        name: "Days In Year",
        value: formData?.terms?.interestCalculationDaysInYearType
          ? templateProdDetail?.interestCalculationDaysInYearTypeOptions?.find(
              (item) => item.id === formData.terms.interestCalculationDaysInYearType,
            )?.value
          : "-",
      },
    ],
    settings: [
      {
        name: "Minimum Opening Balance",
        value: formData?.settings?.minRequiredOpeningBalance
          ? formData.settings.minRequiredOpeningBalance
          : "-",
      },
      {
        name: "Lock-in Period",
        value: formData?.settings?.lockinPeriodFrequency
          ? formData.settings.lockinPeriodFrequency
          : "-",
      },
      {
        name: "Lock-in Period Frequency",
        value: String(formData?.settings?.lockinPeriodFrequencyType)
          ? templateProdDetail?.lockinPeriodFrequencyTypeOptions?.find(
              (item) => item.id === formData?.settings?.lockinPeriodFrequencyType,
            )?.value
          : "-",
        // value: formData?.settings?.lockinPeriodFrequencyType
        //   ? formData?.settings?.lockinPeriodFrequencyType
        //   : "-",
      },
      {
        name: "Apply Withdrawal Fee For Transfers?",
        value:
          formData?.settings?.withdrawalFeeForTransfers === true
            ? "Yes"
            : formData?.settings?.withdrawalFeeForTransfers === false
              ? "No"
              : "--",
      },
      {
        name: "Balance Required For Interest Calculation",
        value: formData?.settings?.minBalanceForInterestCalculation
          ? formData.settings.minBalanceForInterestCalculation
          : "-",
      },
      {
        name: "Enforce Minimum Balance?",
        value:
          formData?.settings?.enforceMinRequiredBalance === true
            ? "Yes"
            : formData?.settings?.enforceMinRequiredBalance === false
              ? "No"
              : "-",
      },
      {
        name: "Minimum Balance",
        value: formData?.settings?.minRequiredBalance ? formData.settings.minRequiredBalance : "-",
      },
      {
        name: "Is Overdraft Allowed?",
        value:
          formData?.settings?.allowOverdraft === true
            ? "Yes"
            : formData?.settings?.allowOverdraft === false
              ? "No"
              : "-",
      },
      {
        name: "Maximum Overdraft Amount Limit",
        value: formData?.settings?.overdraftLimit ? formData.settings.overdraftLimit : "-",
      },
      {
        name: "Nominal Annual Interest For Overdraft?",
        value: formData?.settings?.nominalAnnualInterestRateOverdraft
          ? formData.settings.nominalAnnualInterestRateOverdraft
          : "-",
      },
      {
        name: " Min Overdraft Required For Interest Calculation",
        value: formData?.settings?.minOverdraftForInterestCalculation
          ? formData?.settings?.minOverdraftForInterestCalculation
          : "-",
      },
      {
        name: "Is Lien Allowed?",
        value: formData?.settings?.lienAllowed === true ? "Yes" : "No",
      },
      {
        name: " Maximum Lien Amount",
        value: formData?.settings?.maxAllowedLienLimit
          ? formData.settings.maxAllowedLienLimit
          : "-",
      },
      {
        name: "Is Withhold Tax Applicable?",
        value: formData?.settings?.withHoldTax === true ? "Yes" : "No",
      },
      {
        name: "Tax Group",
        value: formData?.settings?.taxGroupId ? formData.settings.taxGroupId : "-",
      },
      {
        name: "Enable Dormancy Tracking ?",
        value: formData?.settings?.isDormancyTrackingActive === true ? "Yes" : "No",
      },
      {
        name: "Number of Days to Inactive Sub-status ?",
        value: formData?.settings?.daysToInactive ? formData?.settings?.daysToInactive : "-",
      },
      {
        name: " Number of Days to Dormant Sub-status ?",
        value: formData?.settings?.daysToDormancy ? formData?.settings?.daysToDormancy : "-",
      },
      {
        name: "Number of Days to Escheat",
        value: formData?.settings?.daysToEscheat ? formData?.settings?.daysToEscheat : "-",
      },
      {
        name: "Is Domestic Product?",
        value:
          formData?.settings?.isDomestic === true
            ? "Yes"
            : formData?.settings?.isDomestic === false
              ? "No"
              : "--",
      },
    ],
    accounting: [
      {
        name: "Savings Reference",
        value: formData?.account?.savingsReferenceAccountId
          ? templateProdDetail?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.account?.savingsReferenceAccountId,
            ).name
          : "-",
      },
      {
        name: "Overdraft Portfolio",
        value: formData?.account?.overdraftPortfolioControlId
          ? templateProdDetail?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.account?.overdraftPortfolioControlId,
            ).name
          : "-",
      },
      {
        name: "Savings Control",
        value: formData?.account?.savingsControlAccountId
          ? templateProdDetail?.accountingMappingOptions?.liabilityAccountOptions?.find(
              (item) => item.id === formData?.account?.savingsControlAccountId,
            ).name
          : "-",
      },
      {
        name: "Savings Transfers In Suspense",
        value: formData?.account?.transfersInSuspenseAccountId
          ? templateProdDetail?.accountingMappingOptions?.liabilityAccountOptions?.find(
              (item) => item.id === formData?.account?.transfersInSuspenseAccountId,
            ).name
          : "-",
      },
      {
        name: "Escheat Liability",
        value: formData?.account?.escheatLiabilityId
          ? templateProdDetail?.accountingMappingOptions?.liabilityAccountOptions?.find(
              (item) => item.id === formData?.account?.escheatLiabilityId,
            ).name
          : "-",
      },
      {
        name: "Interest On Savings",
        value: formData?.account?.interestOnSavingsAccountId
          ? templateProdDetail?.accountingMappingOptions?.expenseAccountOptions?.find(
              (item) => item.id === formData?.account?.interestOnSavingsAccountId,
            ).name
          : "-",
      },
      {
        name: "Write-off",
        value: formData?.account?.writeOffAccountId
          ? templateProdDetail?.accountingMappingOptions?.expenseAccountOptions?.find(
              (item) => item.id === formData?.account?.writeOffAccountId,
            ).name
          : "-",
      },
      {
        name: "Income From Fees",
        value: formData?.account?.incomeFromFeeAccountId
          ? templateProdDetail?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.account?.incomeFromFeeAccountId,
            ).name
          : "-",
      },
      {
        name: "Income From Penalties",
        value: formData?.account?.incomeFromPenaltyAccountId
          ? templateProdDetail?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.account?.incomeFromPenaltyAccountId,
            ).name
          : "-",
      },
      {
        name: "Overdraft Interest Income",
        value: formData?.account?.incomeFromInterestId
          ? templateProdDetail?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.account?.incomeFromInterestId,
            ).name
          : "-",
      },
    ],
  };

  const columns = [
    [
      {
        key: " 1",
        title: "Name",
        dataIndex: "name",
      },
      {
        key: " 2",
        title: "Type",
        dataIndex: "type",
      },
      {
        key: " 3",
        title: "Amount",
        dataIndex: "amount",
      },
      {
        key: " 4",
        title: "Collected On",
        dataIndex: "collectedOn",
      },
    ],
    [
      {
        key: " 1",
        title: "Payment Type",
        dataIndex: "paymentTypeValue",
      },
      {
        key: " 2",
        title: "Fund Source",
        dataIndex: "fundSourceAccountValue",
      },
    ],
    [
      {
        key: " 1",
        title: "Fees",
        dataIndex: "chargeValue",
      },
      {
        key: " 2",
        title: "Income Account",
        dataIndex: "incomeAccountValue",
      },
    ],
    [
      {
        key: " 1",
        title: "Penalty",
        dataIndex: "penaltyValue",
      },
      {
        key: " 2",
        title: "Income Account",
        dataIndex: "incomeAccountValue",
      },
    ],
  ];

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* DETAILS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Details"}
        </Divider>
        {data.details.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* CURRENCY FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Currency"}
        </Divider>
        {data.currency.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* TERMS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Terms"}
        </Divider>
        {data.terms.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* SETTINGS FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Settings"}
        </Divider>
        {data.settings.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* CHARGES FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Charges"}
        </Divider>
        <Table pagination={false} columns={columns[0]} dataSource={chargeTableSource} />
      </div>

      {/* ACCOUNTING FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Accounting"}
        </Divider>
        {data.accounting.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
      {/* ADVANCED ACCOUNTING */}
      {showAdvancedAccounting && (
        <div
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Divider orientation="left" orientationMargin="0">
            {"Advanced Accounting Rule"}
          </Divider>
          <Table pagination={false} columns={columns[1]} dataSource={configureFundTableSource} />
          <Table pagination={false} columns={columns[2]} dataSource={mapFeeTableSource} />
          {/* <Table
            pagination={false}
            columns={columns[3]}
            dataSource={mapPenaltyTableSource}
          /> */}
        </div>
      )}
    </Card>
  );
};

export default Preview;
